import { HTTP } from '@/services/axios';

export async function createAlias({articleName}){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/core/Common/controlCreateAlias.php?title=${articleName}`
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getStateOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/getStateOptions.php'
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getActivationOptions(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/getActivationOptions.php'
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function loadAccessData(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/loadAccessData.php',
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function loadMenuItem(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/loadMenuData.php'
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function loadVersion(){
    let result = {};

    await HTTP({
        method: 'get',
        url: '/app/core/Common/loadVersion.php'
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}